import React, { PureComponent } from "react";
import Link from "gatsby-link";
import styled from "styled-components";

export default class NextPageSection extends PureComponent {
  render() {

    const Wrap = styled.div`
      margin-bottom: 8vw;
    `
    const Blurb = styled.h5`
      color: ${props =>
        this.props.black ? props.theme.colors.black : props.theme.colors.white};
        margin-bottom: 32px;
    `;

    const Button = styled(Link)`
      margin-right: unset;
      border: 4px solid currentColor;
      background-color: transparent;
      font-size: 22px;
      padding: 20px 30px;
      color: ${props =>
        this.props.black ? props.theme.colors.black : props.theme.colors.white};
      font-weight: 700;
      display: inline-block;
      letter-spacing: 2px;
      text-transform: uppercase;
      text-decoration: none;

      &:hover {
        border: 4px solid ${props =>
            this.props.black
              ? props.theme.colors.black
              : props.theme.colors.white};
        background-color: ${props =>
          this.props.black
            ? props.theme.colors.black
            : props.theme.colors.white};
        color: ${props =>
          this.props.black
            ? props.theme.colors.white
            : props.theme.colors.black};
      }
    `;

    const Separator = styled.div`
      margin-bottom: 48px;
      display: inline-block;
      height: 2px;
      width: 30px;
      background: #e6af2a !important;
    `;

    return (
      <Wrap className={`row text-center ${this.props.className}`} >
        <div className="col-sm-12">
          <Separator />
          <Blurb className="wow fadeInDown">{this.props.blurb}</Blurb>
          <Button className="wow fadeInUp" to={this.props.to}>
            {this.props.linkText}
          </Button>
        </div>
      </Wrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NextPageSection/index.js